import { BLUEPRINT_NAMES } from './blueprintNameMapping';
import { WHITEBOARD_TEMPLATE_IDS } from './whiteboardMappings';

export const teamToTemplatesMapping: {
	[key: string]: Array<WHITEBOARD_TEMPLATE_IDS | BLUEPRINT_NAMES>;
} = {
	'SOFTWARE DEVELOPMENT': [
		BLUEPRINT_NAMES.PRODUCT_REQUIREMENTS,
		WHITEBOARD_TEMPLATE_IDS.SIMPLE_RETROSPECTIVE,
		BLUEPRINT_NAMES.SOFTWARE_ARCHITECTURE_REVIEW,
		BLUEPRINT_NAMES.DEVOPS_RUNBOOK,
		WHITEBOARD_TEMPLATE_IDS.FLOWCHART,
		BLUEPRINT_NAMES.SPRINT_PLANNING_MEETING,
		BLUEPRINT_NAMES.INCIDENT_POSTMORTEM,
	],
	'CUSTOMER SERVICE': [
		BLUEPRINT_NAMES.CUSTOMER_IMPACT_ASSESSMENT,
		WHITEBOARD_TEMPLATE_IDS.SERVICE_BLUEPRINT,
		BLUEPRINT_NAMES.INCIDENT_COMMUNICATION,
		BLUEPRINT_NAMES.TROUBLESHOOTING_ARTICLE,
		BLUEPRINT_NAMES.SMART_GOALS,
	],
	'IT SUPPORT': [
		BLUEPRINT_NAMES.HOW_TO_ARTICLE,
		BLUEPRINT_NAMES.PROJECT_PLAN,
		BLUEPRINT_NAMES.ITSM_KNOWN_ERRORS,
		BLUEPRINT_NAMES.TROUBLESHOOTING_ARTICLE,
		BLUEPRINT_NAMES.ITSM_POST_INCIDENT_REVIEWS,
		WHITEBOARD_TEMPLATE_IDS.SIMPLE_RETROSPECTIVE,
		BLUEPRINT_NAMES.ITSM_RUNBOOK,
		BLUEPRINT_NAMES.ITSM_CHANGE_MANAGEMENT,
	],
	'PRODUCT MANAGEMENT': [
		BLUEPRINT_NAMES.LENNYS_PRODUCT_REQUIREMENTS,
		BLUEPRINT_NAMES.PRODUCT_ROADMAP,
		WHITEBOARD_TEMPLATE_IDS.PRIORITIZATION_MATRIX,
		BLUEPRINT_NAMES.DACI_DECISION_DOCUMENTATION,
		BLUEPRINT_NAMES.STRATEGIC_PLAN,
		WHITEBOARD_TEMPLATE_IDS.BRAINWRITING,
		BLUEPRINT_NAMES.BUSINESS_STATUS_UPDATE,
		WHITEBOARD_TEMPLATE_IDS.USER_STORY_MAP,
	],
	'PROJECT MANAGEMENT': [
		BLUEPRINT_NAMES.PROJECT_PLAN,
		BLUEPRINT_NAMES.STRATEGIC_PLAN,
		WHITEBOARD_TEMPLATE_IDS.SIMPLE_RETROSPECTIVE,
		BLUEPRINT_NAMES.PROJECT_STATUS,
		BLUEPRINT_NAMES.DACI_DECISION_DOCUMENTATION,
		BLUEPRINT_NAMES.OKRS,
		BLUEPRINT_NAMES.ROLES_AND_RESPONSIBILITIES,
		BLUEPRINT_NAMES.PROJECT_KICKOFF,
	],
	DESIGN: [
		BLUEPRINT_NAMES.DESIGN_SYSTEMS,
		BLUEPRINT_NAMES.DESIGN_SPRINT,
		WHITEBOARD_TEMPLATE_IDS.DISRUPTIVE_BRAINSTORM,
		BLUEPRINT_NAMES.CONTENT_STRATEGY,
		BLUEPRINT_NAMES.DESIGN_DECISION,
		BLUEPRINT_NAMES.PERSONA,
		BLUEPRINT_NAMES.DESIGN_REVIEW,
		WHITEBOARD_TEMPLATE_IDS.CRAZY_8S_BRAINSTORMING,
		WHITEBOARD_TEMPLATE_IDS.USER_STORY_MAP,
	],
	MARKETING: [
		BLUEPRINT_NAMES.MARKETING_PLAN,
		BLUEPRINT_NAMES.COMPETITIVE_ANALYSIS,
		WHITEBOARD_TEMPLATE_IDS.USER_STORY_MAP,
		BLUEPRINT_NAMES.SWOT_ANALYSIS,
		BLUEPRINT_NAMES.PERSONA,
		BLUEPRINT_NAMES.MESSAGE_HOUSE,
		WHITEBOARD_TEMPLATE_IDS.BRAINWRITING,
		WHITEBOARD_TEMPLATE_IDS.TIMELINE_WORKFLOW,
	],
	SALES: [
		BLUEPRINT_NAMES.SALES_PORTAL,
		WHITEBOARD_TEMPLATE_IDS.BRAINWRITING,
		BLUEPRINT_NAMES.COMPETITIVE_ANALYSIS,
		BLUEPRINT_NAMES.SWOT_ANALYSIS,
		BLUEPRINT_NAMES.BUSINESS_PLAN_ONE_PAGER,
		BLUEPRINT_NAMES.MESSAGE_HOUSE,
		BLUEPRINT_NAMES.SALES_ACCOUNT_PLANNING,
		BLUEPRINT_NAMES.EXECUTIVE_BUSINESS_REVIEW,
	],
	OPERATIONS: [
		BLUEPRINT_NAMES.PROJECT_PLAN,
		BLUEPRINT_NAMES.BUSINESS_STATUS_UPDATE,
		WHITEBOARD_TEMPLATE_IDS.GAP_ANALYSIS,
		BLUEPRINT_NAMES.TEAM_POSTER,
		BLUEPRINT_NAMES.ANNUAL_PLAN_ONE_PAGER,
		BLUEPRINT_NAMES.BUSINESS_PLAN_ONE_PAGER,
		WHITEBOARD_TEMPLATE_IDS.ANNUAL_CALENDAR,
		BLUEPRINT_NAMES.SWOT_ANALYSIS,
		BLUEPRINT_NAMES.ALL_HANDS_MEETING,
		BLUEPRINT_NAMES.STRATEGIC_PLAN,
	],
	RESEARCH: [
		BLUEPRINT_NAMES.CUSTOMER_INTERVIEW_REPORT,
		WHITEBOARD_TEMPLATE_IDS.USER_STORY_MAP,
		BLUEPRINT_NAMES.PERSONA,
		BLUEPRINT_NAMES.PROJECT_PLAN,
		BLUEPRINT_NAMES.MEETING_NOTES,
		WHITEBOARD_TEMPLATE_IDS.BRAINWRITING,
		BLUEPRINT_NAMES.PRESENTER_MODE,
	],
	FINANCE: [
		BLUEPRINT_NAMES.BUSINESS_STATUS_UPDATE,
		BLUEPRINT_NAMES.BUSINESS_PLAN_ONE_PAGER,
		BLUEPRINT_NAMES.TEAM_POSTER,
		BLUEPRINT_NAMES.PROJECT_STATUS,
		BLUEPRINT_NAMES.VENDOR_AGREEMENT,
		BLUEPRINT_NAMES.QTC_ACQUISITION,
		BLUEPRINT_NAMES.DACI_DECISION_DOCUMENTATION,
		BLUEPRINT_NAMES.RISK_ASSESSMENT_MATRIX,
	],
	'HUMAN RESOURCES': [
		BLUEPRINT_NAMES.HR_KNOWLEDGE_BASE_MANAGEMENT,
		BLUEPRINT_NAMES.PROJECT_PLAN,
		WHITEBOARD_TEMPLATE_IDS.ORG_CHART,
		BLUEPRINT_NAMES.EMPLOYEE_HANDBOOK,
		BLUEPRINT_NAMES.CAREER_DEVELOPMENT_PLAN,
		BLUEPRINT_NAMES.JOB_DESCRIPTION,
		BLUEPRINT_NAMES.TEAM_POSTER,
		BLUEPRINT_NAMES.NINETY_DAY_PLAN,
		BLUEPRINT_NAMES.LENNYS_PERFORMANCE_REVIEW,
		BLUEPRINT_NAMES.VISION_TO_VALUES,
	],
	LEGAL: [
		BLUEPRINT_NAMES.DACI_DECISION_DOCUMENTATION,
		BLUEPRINT_NAMES.RISK_ASSESSMENT_MATRIX,
		BLUEPRINT_NAMES.TO_DO_LIST,
		BLUEPRINT_NAMES.MEETING_NOTES,
	],
	OTHER: [
		BLUEPRINT_NAMES.PROJECT_PLAN,
		WHITEBOARD_TEMPLATE_IDS.BRAINWRITING,
		BLUEPRINT_NAMES.MEETING_NOTES,
		BLUEPRINT_NAMES.TO_DO_LIST,
		BLUEPRINT_NAMES.END_OF_WEEK_STATUS_REPORT,
		BLUEPRINT_NAMES.PRESENTER_MODE,
	],
} as const;
